import './index.scss';
import Initializer from 'lib/initializer';
import ImagesliderApp from './scripts/main';

Initializer.registerComponent('apps/imageslider', function(element) {
  new ImagesliderApp(element);
});
